import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { TenantService } from './services/tenant.service';
import { UIService } from './services/ui.service';
import { UserService } from './services/user.service';

export const iconResolver: ResolveFn<boolean> = async (route, state) => {
    const uiService = inject(UIService);
    await uiService.fetchIcons();
    return true;
};

export const userResolver: ResolveFn<boolean> = async (route, state) => {
    console.log('[UserResolver] Fetching user info');
    const userService = inject(UserService);
    const tenantService = inject(TenantService);
    const userInfo = await lastValueFrom(userService.getUser());
    const tenant = userInfo?.response?.organisationId;
    console.log('[UserResolver] Saving tenant', tenant);
    await tenantService.saveTenant(tenant);
    return true;
};
